import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Background, Page, Subpage, Images, Content, Title, Table, Resume, Button } from "./style";
import Prefeitura from "../../../assets/Images/prefeitura.jpg";
import Fiec from "../../../assets/Images/fiec.png";
import PdfButtons from "../../../components/PdfButtons";
import { formatDatesHoras } from "../../../utils/formatDates";

export default function PdfRelatorioRetiradas() {
  const [retiradas, setRetiradas] = useState([]);
  const [retirou, setRetirou] = useState(true);
  const [totalCestas, setTotalCestas] = useState(0);
  const [totalCestasRetiradas, setTotalCestasRetiradas] = useState(0);
  const [totalBrinquedos, setTotalBrinquedos] = useState(0);
  const [totalBrinquedosRetirados, setTotalBrinquedosRetirados] = useState(0);
  const [mostrarRetiradas, setMostrarRetiradas] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setRetiradas(location?.state?.retiradas || []);
    setRetirou(location?.state?.retirou !== undefined ? location.state.retirou : true);
    setTotalCestas(location?.state?.totalCestas || 0);
    setTotalCestasRetiradas(location?.state?.totalCestasRetiradas || 0);
    setTotalBrinquedos(location?.state?.totalBrinquedos || 0);
    setTotalBrinquedosRetirados(location?.state?.totalBrinquedosRetirados || 0);
  }, [location?.state]);

  return (
    <Background>
      <PdfButtons />
      <Page>
        <Button onClick={() => setMostrarRetiradas(!mostrarRetiradas)}>{mostrarRetiradas ? "Ocultar" : "Mostrar"} datas</Button>
        <Subpage>
          <Images>
            <img src={Fiec} alt="FIEC Logo" />
            <img src={Prefeitura} alt="Prefeitura Logo" />
          </Images>
          <Content>
            <Title>Relatório de Retiradas</Title>
            {mostrarRetiradas && (
              <Resume>
                <span>Status: {retirou ? "Retirou" : "Não Retirou"}</span>
                <span>
                  Cestas: {totalCestasRetiradas}/{totalCestas}
                </span>
                <span>
                  Brinquedos: {totalBrinquedosRetirados}/{totalBrinquedos}
                </span>
              </Resume>
            )}

            <Table>
              <thead>
                <tr>
                  <th>Matrícula</th>
                  <th>Colaborador</th>
                  <th>Cesta</th>
                  <th>Brinquedo</th>
                  <th>Retirada Cesta</th>
                  <th>Retirada Brinquedo</th>
                </tr>
              </thead>
              <tbody>
                {retiradas?.length > 0 ? (
                  retiradas.map((d, i) => (
                    <tr key={`${d?.matricula || "sem-matricula"}-${i}`}>
                      <td>{d?.matricula || "-"}</td>
                      <td>{d?.nome?.toUpperCase() || "-"}</td>
                      <td>{d?.cesta_natal ? "Sim" : "Não"}</td>
                      <td>{d?.qr_code_brinquedo_text != null ? "Sim" : "Não"}</td>
                      <td>{mostrarRetiradas ? formatDatesHoras(d?.data_retirada_cesta) || "-" : ""}</td>
                      <td>{mostrarRetiradas ? formatDatesHoras(d?.data_retirada_brinquedo) || "-" : ""}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6}>Nenhum registro encontrado</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Content>
        </Subpage>
      </Page>
    </Background>
  );
}
